import { NextPageContext } from 'next';
import Script from 'next/script';
import { useContext } from 'react';

import { ReactRouterLayout } from '@vimeo/core/components/ReactRouterLayout';
import { ShowcaseAuthorization } from '@vimeo/showcase-view';
import { ViewerContext } from '@vimeo/viewer';
import { useViewerShowcasesRelease, ViewerShowcasesAuthorization } from '@vimeo/viewer-showcases';

import { NextPage } from '../pages/_app';

const ShowcaseHomePage: NextPage = ({ match, history }) => {
  const viewer = useContext(ViewerContext);
  const { isViewerShowcases } = useViewerShowcasesRelease();

  if (!viewer) {
    return null;
  }

  if (isViewerShowcases) {
    let playerAPIScriptUrl = '';

    if (typeof window !== 'undefined') {
      playerAPIScriptUrl = window.playerAssetUrls.player_api_js;
    }

    return (
      <>
        {playerAPIScriptUrl ? <Script id="player-api" src={playerAPIScriptUrl} /> : null}
        <ViewerShowcasesAuthorization albumIdOrUrl={match.params.albumId} />
      </>
    );
  }

  return (
    <ShowcaseAuthorization
      viewer={viewer}
      match={match}
      history={history}
      location={history.location}
    />
  );
};

export default ShowcaseHomePage;

ShowcaseHomePage.getInitialProps = (ctx: NextPageContext) => {
  const routeRule = ctx.pathname.match(/\/showcase\/\d+/) ? '/showcase/:albumId' : '/';

  return {
    metadata: {
      className: 'ShowcaseMetadata',
      routeRule,
    },
  };
};

ShowcaseHomePage.getLayout = (children) => (
  <ReactRouterLayout path={['/', '/showcase/:albumId']}>{children}</ReactRouterLayout>
);
